module.exports = __webpack_public_path__ + "img/checkpoint.f8f88946.png";